import { FlexCell, FlexRow, Panel } from '@epam/promo';
import { Outlet } from 'react-router-dom';

import { applicationSettingsRoutes } from 'router/applicationSettingsRoutes';
import { VerticalNavigationTabs } from 'components/nav/VerticalNavigationTabs';

interface SubMenuItem {
  caption: string;
  pathname: string;
}

const applicationSettingsSubMenu: SubMenuItem[] = [
  {
    caption: 'Functionality adjustment',
    pathname: applicationSettingsRoutes.functionalityAdjustment,
  },
  {
    caption: 'Personalization',
    pathname: applicationSettingsRoutes.personalization,
  },
  {
    caption: 'Broadcast tags',
    pathname: applicationSettingsRoutes.broadcastTags,
  },
];

export const ApplicationSettingsPage = () => {
  return (
    <FlexRow
      columnGap="24"
      rawProps={{
        style: { margin: '1rem auto', marginRight: '24px', height: '100%' },
      }}>
      <Panel shadow style={{ alignSelf: 'start' }}>
        <VerticalNavigationTabs menuItems={applicationSettingsSubMenu} />
      </Panel>
      <FlexCell grow={1} style={{ alignSelf: 'stretch' }}>
        <Panel shadow style={{ height: '100%' }}>
          <Outlet />
        </Panel>
      </FlexCell>
    </FlexRow>
  );
};
